import React from "react";

const LocationsPage = () => {
  return <div></div>;
};

export default LocationsPage;
